<div class="dashboardDeleteOverlay">
    <div class="bg"></div>

    <div class="content">
        <div class="closeHolser">
            <div class="close" (click)="close()">
                <mat-icon>close</mat-icon>
            </div>
        </div>

        <div class="confirm">
            IMPORTANT: <br><br>
            Are you sure you want to delete this account?
        </div>
        <div class="buttons">
            <div class="cancel" (click)="close()">
                <div class="label">Cancel</div>
            </div>

            <div class="save" >
                <div class="label" (click)="confirm()">Delete Account</div>
            </div>
        </div>
    </div>
</div>